import React, { FC } from 'react';
import { createChunkReloadGuard } from '@srm/core/version';
import { AppErrorBoundary as UiAppErrorBoundary, type IAppErrorFallbackProps } from '@srm/ui/shell/AppErrorBoundary';
import ErrorPage from '@pages/errorPage/ErrorPage';
import { AppMantineProvider } from '@providers/AppMantineProvider/AppMantineProvider';
import { BASE_PATH } from '@/configuration';

interface AppErrorBoundaryProps {
    children: React.ReactNode;
}

// Ключ тихой перезагрузки — свой у Front: админка на том же origin делит с ним вкладку и sessionStorage.
const chunkReload = createChunkReloadGuard({ namespace: 'front' });

// Свой MantineProvider: boundary стоит выше корневого, и при ошибке тот выкидывается
// вместе с children, а ErrorPage собран из Mantine-фасадов (@atoms/Button и др.).
const AppErrorFallback: FC<IAppErrorFallbackProps> = (props) => (
    <AppMantineProvider>
        <ErrorPage {...props} />
    </AppMantineProvider>
);

const goHome = () => window.location.replace(BASE_PATH);

export const AppErrorBoundary: FC<AppErrorBoundaryProps> = ({ children }) => (
    <UiAppErrorBoundary FallbackComponent={AppErrorFallback} onReset={goHome} chunkReload={chunkReload}>
        {children}
    </UiAppErrorBoundary>
);
